import { useEffect } from 'react'

import { useOrganization } from '@application/Interfaces/Hooks/useOrganization/useOrganization'
import { useGrowthBook } from '@growthbook/growthbook-react'

export const useSetOrganizationAttributes = (): null => {
    const growthbook = useGrowthBook()
    const organization = useOrganization()

    useEffect(() => {
        if (!growthbook) return

        growthbook.setAttributes({
            ...growthbook.getAttributes(),
            organization: organization.type,
        })
    }, [growthbook])

    return null
}
